<template>
  <v-row v-if="list.length">
    <v-col cols="12">
      <v-card>
        <v-toolbar dense flat color="tertiary">
          <v-toolbar-title class="custon-toolbar-title">Listagem de Motoristas</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text class="py-0">
          <v-data-table
            :headers="headers"
            :items="list"
            :item-key="list.id"
            :loading="loading"
            :server-items-length="paginate.total"
          >
            <template v-slot:item.ativo="{ item }">
              <v-btn
                fab
                x-small
                depressed
                tag="div"
                :color="item.ativo ? 'green lighten-4' : 'red lighten-4'"
              >
                <v-icon :color="item.ativo ? 'green' : 'red'" small>{{
                  item.ativo ? 'mdi-check' : 'mdi-close'
                }}</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.acoes="{ item }">
              <v-btn @click="destroyConfirm(item)" fab depressed dark x-small color="red lighten-4">
                <v-icon color="red" small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastMessage, { confirmDestroyAlert } from '@/services/util/alertService';

export default {
  name: 'VeiculoMotoristaTable',
  data: () => ({
    headers: [
      {
        text: 'Nome',
        value: 'motorista.pessoa.nome',
        sortable: false,
      },
      {
        text: 'CNH',
        value: 'motorista.categoria_cnh.nome',
        align: 'center',
        sortable: false,
        width: '8%',
      },
      {
        text: 'Ativo',
        value: 'ativo',
        align: 'center',
        sortable: false,
        width: '8%',
      },
      {
        text: 'Ações',
        value: 'acoes',
        width: '8%',
        align: 'center',
        sortable: false,
      },
    ],
  }),
  created() {
    this.getAll(this.data.id);
  },
  methods: {
    ...mapActions('veiculoMotorista', ['getAll', 'destroy']),
    destroyConfirm(item) {
      confirmDestroyAlert(item.motorista.pessoa.nome).then((result) => {
        if (result.value) {
          this.destroy(item)
            .then(() => toastMessage.successDestroy('Motorista removido com sucesso'))
            .catch(() => toastMessage.errorDestroy('Erro ao remover motorista'));
        }
      });
    },
  },
  computed: {
    ...mapState('veiculoMotorista', ['loading', 'list', 'paginate']),
    ...mapState('veiculo', ['data']),
  },
};
</script>
